import { FreedataCall, GetVisionCommand, StyleEngine, VisionStepPerimeterCommand } from '@wizeoo/akm-common-lib';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, CODE_SPACE, VALUE_ENTER, WizMathUtils,} from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizButton,
  WizComponentManager,
  WizDatasource,
  WizDropdown,
  WizDropItemEvent,
  WizFocusManager,
  WizGroupCommand,
  WizIcon,
  WizImage,
  WizList,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizTileList,
  WizTranslationBasic,
  WizTranslationInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizCheckbox,
  BATCH_FILE_FORMAT,
  ImageUploadParameter,
  WizEventManager, WizEvent,
  WizTextarea
} from '@wizeoo/akm-component-lib';
import { ChronocodeCmd } from '@wizeoo/akm-common-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { PermissionAccess } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, VISION_PROPERTY } from '@wizeoo/akm-common-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';
import { ChronoCodeLevelVO } from '@wizeoo/akm-common-lib';
import { FreeDataVO } from '@wizeoo/akm-common-lib';
import { FreedataLevelVO } from '@wizeoo/akm-common-lib';
import { FreedataValueVO } from '@wizeoo/akm-common-lib';
import { VisionKeyObj } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { Model } from '../../model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import {
  PermissionVisibility,
  StaticFeatureEnum,
  ViewPermission,
} from '@wizeoo/akm-common-lib';
import { OrderedVisionKeyRenderer } from './renderer/ordered-vision-key.renderer';
import { StepKeyRenderer } from './renderer/step-key.renderer';
import { VisionKeyRenderer } from '@wizeoo/akm-common-lib';
import { VisionMeasureListRenderer } from './renderer/vision-measure-list.renderer';
import { VisionMeasureRenderer } from './renderer/vision-measure.renderer';
import { VisionStepRenderer } from './renderer/vision-step.renderer';
import { FindVisionCommand } from '@wizeoo/akm-common-lib';
import { VisionThumbRenderer } from './renderer/vision-thumb.renderer';
import { MeasureVO, VisionVO } from '@wizeoo/akm-compute-lib';
import { Measure, VisionFilterKey, VisionKey, VisionStep, VisionStepPerimeter } from '@wizeoo/akm-message-lib';
import { TranslatableLabelVO } from '@wizeoo/akm-common-lib';
import { ColorPickerPop } from '@wizeoo/akm-common-lib';

/**
 * Vue d'administation des profils utilisateurs
 * Author : sva
 */
@Component({
  selector: 'vision-view',
  templateUrl: './vision.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisionView extends BaseView {
  // zone détail
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false }) vgDetailZone: WizVgroup;
  @ViewChild('vgDetailZone', { read: WizValidationContainerDirective, static: false }) private vgDetailZoneValidator: WizValidationContainerDirective;

  @ViewChild('multiDisp', { read: MultiDisplay })
  multiDisp: MultiDisplay<VisionVO>;
  /** Button d'ajout de profil */
  @ViewChild('btnAddVision', { read: WizIcon }) btnAddVision: WizIcon;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon }) btnExport: WizIcon;
  /** Bouton d'export en masse */
  @ViewChild('btnMassExport', { read: WizIcon }) btnMassExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon }) btnImport: WizIcon;
  /** Button d'import en masse */
  @ViewChild('btnMassImport', { read: WizIcon }) btnMassImport: WizIcon;

  /** Text input de saisie du code */
  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput;
  /** drop de choix du chronocode */
  @ViewChild('ddChrono', { read: WizDropdown }) ddChrono: WizDropdown;
  /** Composant de saisie du libellé traductible */
  @ViewChild('tiLabelTrs', { read: WizTranslationInput }) tiLabelTrs: WizTranslationInput;

  /** Composant de saisie de la description */
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;
  /** Composant de sélection de l'icone */
  @ViewChild('uploadImg', { read: WizImage }) uploadImg: WizImage;
  /** drop de statut */
  @ViewChild('ddStatus', { read: WizDropdown }) ddStatus: WizDropdown;
  /** drop de mode de lancement */
  @ViewChild('ddRunMode', { read: WizDropdown }) ddRunMode: WizDropdown;
  /** utilisation des scenars */
  @ViewChild('cbUseScen', { read: WizCheckbox }) cbUseScen: WizCheckbox;
  /** navigation excel vs web */
  @ViewChild('cbWebNav', { read: WizCheckbox }) cbWebNav: WizCheckbox;
    

  
  /** utilisation des exports PDF en bas de page*/
  @ViewChild('cbUsePdfExport', { read: WizCheckbox }) cbUsePdfExport: WizCheckbox;
  /** utiliser les calculs remotes */
  @ViewChild('cbUseCompute', { read: WizCheckbox }) cbUseCompute: WizCheckbox;

  /** calcul remote sur commit */
  @ViewChild('cbAutoCompute', { read: WizCheckbox }) cbAutoCompute: WizCheckbox;

  /** cron pour déclencher le calcul remote */
  @ViewChild('tiComputeCron', { read: WizTextInput }) tiComputeCron: WizTextInput;


  /** couleur des barres de menus */
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background


  /** mail du support */
  @ViewChild('tiSupportMail', { read: WizTextInput }) tiSupportMail: WizTextInput;
  /** url de l'aide en ligne */
  @ViewChild('tiHelpURL', { read: WizTextInput }) tiHelpURL: WizTextInput;

  /** params de conf + */
  @ViewChild('taSettings', { read: WizTextarea }) taSettings: WizTextarea;

  /** Bouton de sauvegarde */
  @ViewChild('btnSave', { read: WizButton }) btnSave: WizButton;
  /** Bouton d'annulation de saisie */
  @ViewChild('btnCancel', { read: WizButton }) btnCancel: WizButton;
  /** Bouton suppression */
  @ViewChild('btnRemove', { read: WizIcon }) btnRemove: WizIcon;

  // listes des clés disponibles
  @ViewChild('lstFreeKeys', { read: WizList }) lstFreeKeys: WizList;
  /** filtre des clés libres  */
  @ViewChild('lstFreeKeysFilter', { read: FilterComponent, static: false }) lstFreeKeysFilter: FilterComponent;

  // listes des clés
  @ViewChild('lstKeys', { read: WizList }) lstKeys: WizList;
  // listes des filtres
  @ViewChild('lstFilterKeys', { read: WizList }) lstFilterKeys: WizList;

  // listes des mesures disponibles
  @ViewChild('lstFreeMeasures', { read: WizTileList })
  lstFreeMeasures: WizTileList;
  // listes des mesures
  @ViewChild('lstMeasures', { read: WizList }) lstMeasures: WizList;
  /** filtre des mesures */
  @ViewChild('freeMeasureFilter', { read: FilterComponent })
  freeMeasureFilter: FilterComponent;

  // zone d'ajout des steps
  @ViewChild('stepContainer', { read: ViewContainerRef, static: true })
  stepContainer: ViewContainerRef;

  /** Renderer des steps */
  public stepKeyRenderer: any = StepKeyRenderer;
  /** renderer des mesures */
  public measureRenderer: any = VisionMeasureRenderer;
  public measureListRenderer: any = VisionMeasureListRenderer;
  /** Renderer des keys */
  public visionKeyRenderer: any = VisionKeyRenderer;
  /** Renderer des keys ordonnées (visionKey) */
  public orderedVisionKeyRenderer: any = OrderedVisionKeyRenderer;


  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }


  public currentVision: VisionVO = null; // vision en cours, sert aussi de flag pour afficher le détail / le cartouche
  public clone: VisionVO = null; // le clone de travail

  // private visionKeyUpdateFlag: boolean = false; // flag qui signale une modif sur la structure des visionKeys
  // private avoidBadUpdateOnServiceReturn: boolean = false; // éviter l'update de la liste des steps sur retour de validation

  /** chronocodes de la drop */
  private chronoDS: WizDatasource<ChronocodeVO>;

  public visionDS: WizDatasource<VisionVO> = new WizDatasource<VisionVO>([])
    .setSortFields([{ property: 'code', way: 'asc' }])
    .setFilter(this.visionFilterFunc.bind(this))
    .build();

  /** DS de la drop de statuts */
  private visionStateDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().visionStateList)
    .setSortFields([{ property: 'order', way: 'asc' }])
    .build();

  /** DS de la drop des modes de lancement */
  private runModeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().runModeList)
    .setSortFields([{ property: 'order', way: 'asc' }])
    .build();

  /** pool d'axes libres */
  private freeKeyDS: WizDatasource<VisionKeyObj> = new WizDatasource<VisionKeyObj>()
    .setSortFields([{ property: 'code', way: 'asc', numeric: true }])
    .setFilter(this.freeKeysFilterFunc.bind(this))
    .build();

  /** les clés de la vision */
  public keyDS: WizDatasource<VisionKeyObj> = new WizDatasource<VisionKeyObj>().build();
  // pas de sort, sinon prb de drag'n'drop (plus possible d'ordonner) .setSortFields([{ property: 'order', way: 'asc', numeric: true }])

  /** les clés de filtre de la vision */
  private filterKeyDS: WizDatasource<VisionKeyObj> = new WizDatasource<VisionKeyObj>().build();

  /** toutes les mesures disponibles */
  public freeMeasureDS: WizDatasource<MeasureVO> = new WizDatasource<MeasureVO>()
    .setSortFields([{ property: 'code', way: 'asc' }])
    .setFilter(this.measureFilterFunc.bind(this))
    .build();

  /** les mesures de la vision */
  private visionMeasureDS: WizDatasource<MeasureVO> = new WizDatasource<MeasureVO>()
    .setSortFields([{ property: 'code', way: 'asc' }])
    .setFilter(this.measureFilterFunc.bind(this))
    .build();

  /* #############################################################
                        CYCLE DE VIE WizView
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // disponibilité des chronocodes pour labels
    if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      commands.push(new ChronocodeCmd(Model.getInstance()).find());
    }

    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      commands.push(new FreedataCall(Model.getInstance()));
    }

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands);
    } else {
      return null;
    }
  }

  private get viewPermissions(): ViewPermission[] {
    return [
      {
        feature: StaticFeatureEnum.VISION,
        permissions: [
          {
            component: this.btnAddVision,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnRemove,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.vgDetailZone,
            accesses: [PermissionAccess.UPDATE, PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnMassExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnMassImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ];
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;

    this.visionDS.setSource([...Model.getInstance().visionEngine.visionDS.getSource()]);

    // alimentation de la drop des chronocodes
    this.chronoDS = new WizDatasource<ChronocodeVO>(Model.getInstance().chronocodeTreeList)
      .setSortFields([{ property: 'level', way: 'asc' }, { property: 'code', way: 'asc' }])
      .build();


    // liaison de la fonction de contrôle sur la liste des clés
    this.lstKeys.dropControlFunction = this.dropKeyAdvanced.bind(this);
    this.lstFreeKeys.dropControlFunction = this.dropKeyBasic.bind(this);
    this.lstFilterKeys.dropControlFunction = this.dropKeyFilterBasic.bind(this);
    // fonctions de contrôle sur les listes de measures
    this.lstFreeMeasures.dropControlFunction = this.dropMeasureBasic.bind(this);
    this.lstMeasures.dropControlFunction = this.dropMeasureBasic.bind(this);

    // construction des filtres du grid
    this.buildFilter();
    this.feed();
  }

  /**
   * Mise en place des écouteurs
   */
  public wizAddListener(): void {
    super.wizAddListener()
    // sur modification de la collection, recalcul de l'ordre des keys
    WizEventManager.addListener(this, this.lstKeys, WIZ_EVENT_TYPE.DRAG_DROPPED, this.checkKeyOrder);
    WizEventManager.addListener(this, this.lstKeys, WIZ_EVENT_TYPE.DRAG_MOVED, this.checkKeyOrder);
    WizEventManager.addListener(this, this.lstKeys, WIZ_EVENT_TYPE.DROP_LOST_ITEM, this.checkKeyOrder);

    // sur modification de la collection, recalcul de l'ordre des keys (filterKey)
    WizEventManager.addListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DRAG_DROPPED, this.checkFilterKeyOrder);
    WizEventManager.addListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DRAG_MOVED, this.checkFilterKeyOrder);
    WizEventManager.addListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DROP_LOST_ITEM, this.checkFilterKeyOrder);

    // merge (create / update sur btnSave)
    WizEventManager.addListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK, this.doMerge);
    // revert (btCancel)
    WizEventManager.addListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK, this.doRevert);
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);

    WizEventManager.addListener(this, this.lstMeasures, WIZ_EVENT_TYPE.DRAG_DROPPED, this.updateModel);
    WizEventManager.addListener(this, this.lstMeasures, WIZ_EVENT_TYPE.DROP_LOST_ITEM, this.updateModel);

    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.KEY_STEP_UP, this.keyStepUp); // modification de l'ordre des steps
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.KEY_STEP_DOWN, this.keyStepDown); // modification de l'ordre des steps

    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.refreshMultiDS); // modification de la portée vision au niveau de l'appli, rechargement

    WizEventManager.addListener(this, this.lstFreeMeasures, ALK_EVENT_TYPE.ADD_MEASURE, this.addMeasure); // ajout d'une mesure à la vision
    WizEventManager.addListener(this, this.lstMeasures, ALK_EVENT_TYPE.REMOVE_MEASURE, this.removeMeasure); // suppression d'une mesure de la vision
    WizEventManager.addListener(this, this.freeMeasureFilter, WIZ_EVENT_TYPE.CHANGE, this.filterMeasures); // modification du filtre des mesures

    WizEventManager.addListener(this, this.lstFreeKeysFilter, WIZ_EVENT_TYPE.CHANGE, this.filterKeys); // modification du filtre des clés libres

    // écoute du retour d'import (batch pour refresh de la vue)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
  }

  private refreshMultiDS(e: AlkEvent): void {
    // console.log('refreshMultiDS', e);
    this.multiDisp.datasource.refresh();
  }

  /**
   * Suppression des écouteurs
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.lstKeys, WIZ_EVENT_TYPE.DRAG_DROPPED);
    WizEventManager.removeListener(this, this.lstKeys, WIZ_EVENT_TYPE.DRAG_MOVED);
    WizEventManager.removeListener(this, this.lstKeys, WIZ_EVENT_TYPE.DROP_LOST_ITEM);

    WizEventManager.removeListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DRAG_DROPPED);
    WizEventManager.removeListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DRAG_MOVED);
    WizEventManager.removeListener(this, this.lstFilterKeys, WIZ_EVENT_TYPE.DROP_LOST_ITEM);

    // merge (create / update sur btnSave)
    WizEventManager.removeListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK);
    // revert (btCancel)
    WizEventManager.removeListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE);

    WizEventManager.removeListener(this, this.lstMeasures, WIZ_EVENT_TYPE.DRAG_DROPPED);
    WizEventManager.removeListener(this, this.lstMeasures, WIZ_EVENT_TYPE.DROP_LOST_ITEM);

    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.KEY_STEP_UP);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.KEY_STEP_DOWN);

    WizEventManager.removeListener(this, this.lstFreeMeasures, ALK_EVENT_TYPE.ADD_MEASURE); // ajout d'une mesure à la vision
    WizEventManager.removeListener(this, this.lstMeasures, ALK_EVENT_TYPE.REMOVE_MEASURE);
    WizEventManager.removeListener(this, this.freeMeasureFilter, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.lstFreeKeysFilter, WIZ_EVENT_TYPE.CHANGE);

    // écoute du retour d'import (batch pour refresh de la vue)
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }



  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.VISION, BATCH_FILE_FORMAT.JSON, !!this.currentVision ? this.currentVision.code : null);
        break;
      case 'massExport':
        // Par défaut, que l'on filtre ou non sur une vision, on va extraire les baselines (option de scénario d'extraction gérée au travers du CriteriaKey)
        let criteriaKey: string = 'BASELINE'
        if (!!this.currentVision) {
          criteriaKey = criteriaKey + '|VISION=' + this.currentVision.code;
        }
        Model.getInstance().batchEngine.export(BATCH_KIND.META_VISION, null, criteriaKey);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.VISION);
        break;
      case 'massImport':
        Model.getInstance().batchEngine.import(BATCH_KIND.META_VISION);
        break;
      case 'delete':
        this.askForDelete();
        break;
      case 'create': // demande de create
        this.askForAdd();
        break;
      case 'addAllMeasures': // demande de create
        this.manageAllMeasures(true);
        break;
      case 'removeAllMeasures': // demande de create
        this.manageAllMeasures(false);
        break;
    }
  }

  /** Fonction de controle du drop (objet hiérarchique, pas d'enfants avant les parents) */
  public dropKeyAdvanced({ item, targetPosition }: WizDropItemEvent): boolean {
    const visionKey: VisionKeyObj = item.data;
    if (visionKey instanceof VisionKeyObj) {
      const arr: VisionKeyObj[] = this.keyDS && this.keyDS !== undefined ? this.keyDS.getWorkedSource() : null;

      let result: boolean = true;
      if (arr && visionKey.level > 0) {
        // pas besoin de tester les axes plats
        arr.forEach((exist: VisionKeyObj) => {
          if (exist.baseCode === visionKey.baseCode) {
            if (exist.level > visionKey.level && exist.order <= targetPosition) {
              result = false;
            } else if (exist.level < visionKey.level && exist.order > targetPosition) { // pas >=, les orders commencent à 1
              result = false;
            }
          }
        });
      }
      return result;
    } else {
      // pas un VisionKeyObj
      return false;
    }
  }

  /** Fonction de controle du drop sur les Keys : un VisionKeyObj ou rien */
  public dropKeyBasic({ item }: WizDropItemEvent): boolean {
    if (item.data instanceof VisionKeyObj) {
      return true;
    } else {
      // pas un VisionKeyObj
      return false;
    }
  }

  /** Fonction de controle du drop sur les Keys : un VisionKeyObj ou rien */
  public dropKeyFilterBasic({ item }: WizDropItemEvent): boolean {
    if (item.data instanceof VisionKeyObj) {
      if ((item.data as VisionKeyObj).isChronocode) {
        return false;
      } else {
        return true;
      }
    } else {
      // pas un VisionKeyObj
      return false;
    }
  }

  /** Fonction de controle du drop sur les measures : un MeasureVO ou rien */
  public dropMeasureBasic({ item }: WizDropItemEvent): boolean {
    return item.data instanceof MeasureVO;
  }

  /**
   * sur modification de la collection, recalcul de l'ordre des keys
   */
  private checkKeyOrder(e: WizEvent): void {
    // console.log('dnd', e, e.value);
    let idx: number = 1;
    this.keyDS.getWorkedSource().forEach((item: VisionKeyObj) => {
      item.order = idx;
      idx++;
    });
    this.updateModel(e);
  }

  /**
   * sur modification de la collection, recalcul de l'ordre des keys (filter)
   */
  private checkFilterKeyOrder(e: WizEvent): void {
    // console.log('dnd', e, e.value);
    let idx: number = 1; // le 1, c'est le chrono racine
    this.filterKeyDS.getWorkedSource().forEach((item: VisionKeyObj) => {
      item.order = idx;
      idx++;
    });
    this.updateModel(e);
  }

  /** mémorisation du filtre */
  wizOnDestroy(): void {
    super.wizOnDestroy();
  }

  /* ##############################################################################
                    Panneau gauche : Liste, sélection, filtres
     ############################################################################## */

  /**
   * configuration de l'affichage en multi liste
   */
  public multiDisplayConfig: MultiDisplayConfig<VisionVO> = {
    model: Model.getInstance(),
    datasource: this.visionDS,
    defaultMode: 'grid',
    onSelectionChanging: this.onWizEventSelectionChange.bind(this),
    grid: {
      enabled: true,
      columns: [
        {
          headerName: ' ',
          field: 'code',
          width: 40,
          sortable: false,
          cellRenderer: 'visionThumbRenderer'
        },
        {
          headerName: '$.common.code.$',
          field: 'code',
          tooltipField: 'code',
          width: 100,
          sortable: true,
        },
        {
          headerName: '$.common.label.$',
          field: 'trsLabel',
          tooltipField: 'trsLabel',
          flex: 1,
          sortable: false,
        },
      ],
      renderers: {
        visionThumbRenderer: VisionThumbRenderer
      },
    },
    tiles: {
      enabled: false, renderer: null
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  private mainFilter: FilterComponent;

  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /**
   * construction de la zone de filtre des visions
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(_: WizEvent = null): void {
    this.mainFilter.configure(['code', 'trsLabel'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    Model.getInstance().userContextService.feedFilterContext(this.mainFilter);

    this.freeMeasureFilter.configure(['shortCode', 'trsLabel', 'formulaI'], null, null);
    this.lstFreeKeysFilter.configure(['code', 'label'], null, null);
  }

  /**
   * Callback de selection dans le grid
   * @param pEvent WizEvent
   */
  private onWizEventSelectionChange(e: WizEvent): void {
    // empêche le changement de selection quand il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // on stop le fonctionnement par défaut pour afficher la pop, on sélectionnera l'item seulement si le user confirme
      e.preventDefault();

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSwap.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        e.value,
        null,
        this.clone
      ).show();
    } else {
      if (!this.visionDS.isSelected(e.value)) {
        // pas encore sélectionné
        this.doSelect(e.value);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  private doSelect(vision: VisionVO) {
    // console.log(vision.uniqueKey, vision.loaded);
    if(!vision.loaded) {
      new GetVisionCommand(this.model).get(vision.source, this.backFromVisionCall.bind(this)).execute();
    } else 
    {
      this.doSelectReally(vision);
    }

  }

  private backFromVisionCall(cmd: GetVisionCommand): void {
    this.visionDS.setSource([...Model.getInstance().visionEngine.visionDS.getSource()]);
    let v: VisionVO = this.visionDS.getItemByKey(cmd.vision.code);
    // console.log('backFromVisionCall synchro', cmd, v);
    this.doSelectReally(v);
  }

  private doSelectReally(vision: VisionVO): void {
    this.currentVision = vision;
    // console.log(vision.uniqueKey, vision.loaded);
    
    this.clone = !!this.currentVision ? Model.getInstance().visionEngine.clone(vision) : null;
    this.feed();
  }


  /**
   * Confirmation de la sélection de la BU, on met à jour la datasource puis la vue
   * On ne peut pas passer directement par le doSelectBu car la méthode est utilisée aussi
   * dans le cas ou on ne prevent pas la sélection. On ferait le toggleSelect deux fois sinon
   * @param result: Objet ConfirmationResultObj contenant le choix effectué sur la popup
   */
  private confirmSwap(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      this.doSelect(result.data);
      this.visionDS.select([result.data]);
      this.feed();
    }
  }

  /* #########################################
                    Detail
     ######################################### */

  public get isDetailVisible() {
    const result =
      !!this.currentVision &&
      Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.VISION,
        accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
        visibility: PermissionVisibility.DISABLED,
      });
    return result;
  }

  /**
   * Initialisation des valeurs des champs dans le conteneur d'edition en fonction du currentCountry
   */
  public feed(): void {
    if (!!this.clone) {
      // alimentation du code
      this.tiCode.wizValue = this.clone.code;
      this.tiCode.wizDisabled =
        this.clone.id > 0 ||
        !Model.getInstance().permissionEngine.hasAnyPermission({
          feature: StaticFeatureEnum.VISION,
          accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
          visibility: PermissionVisibility.DISABLED,
        }); // édition du code

      // alimentation des libellés
      let labelVO: TranslatableLabelVO = Model.getInstance().visionEngine.getVisionProperties(this.clone, VISION_PROPERTY.LABEL);
      let descriptionVO: TranslatableLabelVO = Model.getInstance().visionEngine.getVisionProperties(this.clone, VISION_PROPERTY.DESCRIPTION);


      this.tiLabelTrs.translationData = Model.getInstance().localeEngine.buildTranslationData(labelVO);
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(descriptionVO);
      this.uploadImg.sourceObservable = Model.getInstance().visionEngine.getVisionIconOrDie(this.clone);

      this.tiSupportMail.wizValue = this.clone.supportMail;
      this.tiHelpURL.wizValue = this.clone.helpURL;

      this.cbUseScen.wizChecked = this.clone.useScenario;
      this.cbWebNav.wizChecked = this.clone.navigationMode === ViewData.NAVIGATION_WEB;
      this.cbUsePdfExport.wizChecked = this.clone.usePdfExport;
      this.cbUseCompute.wizChecked = this.clone.useCompute;
      this.cbAutoCompute.wizChecked = this.clone.autoCompute;
      this.tiComputeCron.wizValue = this.clone.computeCron;

      // couleur des barres de menu
      if (!!this.clone.color) {
        this.backgroundColor = this.clone.color;
      } else {
        this.backgroundColor = StyleEngine.STYLE_DEFAULT_BAR_COLOR;
      }

      this.ddChrono.wizDataProvider = this.chronoDS; // alimentation de la drop des chronos
      let chrono: ChronocodeVO = Model.getInstance().chronocodeEngine.getChronocode(this.currentVision.chronoCode);
      this.chronoDS.select([chrono]);
      this.ddStatus.wizDataProvider = this.visionStateDS; // alimentation de la drop des statuts
      let st: any = FakeVO; // le statut en forme "objet"
      if (this.currentVision.status) {
        st = this.visionStateDS.getItemByKey(this.currentVision.status);
      }
      this.visionStateDS.select([st]);

      this.ddRunMode.wizDataProvider = this.runModeDS; // alimentation de la drop des statuts
      let rm: any = FakeVO; // le statut en forme "objet"
      if (this.currentVision.runMode) {
        rm = this.runModeDS.getItemByKey(this.currentVision.runMode);
      }
      this.runModeDS.select([rm]);


      // génération du settings en mode string
      if(this.clone.settings) {
        this.clone.settingsStr = JSON.stringify(this.clone.settings);
      }
      this.taSettings.wizValue = this.clone.settingsStr;


      this.feedKeys(); // construction des listes des clés
      this.feedMeasures(); // construction de la liste des mesures

      this.buildSteps(); // construction des steps

      // this.checkFormulaIntegrity(); // contrôle de la cohérence des formules

      // focus du premier champs actif
      this.focusFormFields();
      // passe le model update a false
      this.resetModelUpdate();

    } else {
      this.reset();
    }

    super.managePermissions(this.viewPermissions);

    this.vgDetailZone.visible = this.isDetailVisible;
    this.btnRemove.wizDisabled =
      !this.currentVision ||
      this.currentVision.id <= 0 ||
      !Model.getInstance().permissionEngine.canDelete(
        StaticFeatureEnum.VISION,
        Model.getInstance().userAppEngine.newUserApp(
          this.currentVision.domain,
          this.currentVision.businessUnitCode,
          this.currentVision.code
        )
      );
  }

  /** alimentation des collections de mesure */
  public feedMeasures(): void {
    const freeM: MeasureVO[] = []; // les mesures disponibles
    const visiM: MeasureVO[] = []; // les mesures de la vision

    // la map des mesures portées par cette vision
    const visiMap: Map<string, MeasureVO> = new Map(this.currentVision.measures?.map((item: Measure) => [item.code, new MeasureVO(item)]));



    const allMeasures: MeasureVO[] = []; // l'ensemble des mesures disponibles, les vraies, et les prototypes depuis les FDVs
    let fakeMeasure: MeasureVO;
    Model.getInstance().freedataEngine.getFreeDataCollection().forEach((fd: FreeDataVO) => {
      if (fd.kindMeasure) {
        fd.getValuesVO().forEach((fdv: FreedataValueVO) => {
          fakeMeasure = Model.getInstance().measureEngine.buildFake(this.currentVision);
          fakeMeasure.code = fdv.freeDataCode + ViewData.CONTEXT_SEPARATOR + fdv.code; // code sous la forme FD#FDVCode
          fakeMeasure.shortCode = fdv.freeDataCode + ViewData.CODE_LEVEL_SEPARATOR + fdv.shortCode; // shortCode (visible) sous la forme FD_FDVShortCode
          fakeMeasure.label = fdv.label;
          allMeasures.push(fakeMeasure);

          if (visiMap.has(fakeMeasure.code)) { // elle est dans la vision
            visiM.push(fakeMeasure);
          } else {
            freeM.push(fakeMeasure); // ou pas
          }
        });
      }
    });
    this.freeMeasureDS.setSource(freeM);
    this.visionMeasureDS.setSource(visiM);
    this.lstFreeMeasures.wizDataProvider = this.freeMeasureDS;
    this.lstMeasures.wizDataProvider = this.visionMeasureDS;
  }

  /** alimentation des 3 listes de clés */
  public feedKeys(): void {
    // construction du pool de visionKeyObj kind(CRO/FDV)#code#level = obj
    const allKeyMap: Map<string, VisionKeyObj> = new Map<string, VisionKeyObj>();
    let key: string;
    let obj: VisionKeyObj;

    // alimentation des freeDatas
    Array.from(Model.getInstance().freedataEngine.getFreedataMap().values()).forEach((item: FreeDataVO) => {
      if (!item.kindMeasure) {
        if (!item.levelsVOMap || item.levelsVOMap.size === 0) {
          Model.getInstance().freedataEngine.addFreeDataLevel(item, Model.getInstance().freedataEngine.createFreedatalevel(item,1));
        }

        item.levelsVOMap.forEach((fdvl: FreedataLevelVO) => {
          key = VisionKeyObj.FREEDATA + VisionKeyObj.SEPARATOR + item.code + VisionKeyObj.SEPARATOR + fdvl.level;
          obj = new VisionKeyObj(item, 'free', 0, fdvl.level);
          allKeyMap.set(key, obj);
        });
      }
    });

    // alimentation des chronocodes. Uniquement les enfants de la sélection.
    // pas les chronocodes, les levels
    if (this.clone.chronoCode) {
      let chrono: ChronocodeVO = Model.getInstance().chronocodeEngine.getChronocode(this.clone.chronoCode);
      if (!!chrono) { // devrait pas arriver, chronocode absent
        const baseLvl: number = chrono.level;

        // prise du niveau du chrono
        Object.values(chrono.chronoCodeLevelVOs || {}).forEach((crol: ChronoCodeLevelVO) => {
          if (crol.level >= baseLvl) {
            key = VisionKeyObj.CHRONO + VisionKeyObj.SEPARATOR + crol.code + VisionKeyObj.SEPARATOR + crol.level;
            // console.log('cron', key, crol.trsLabel);
            obj = new VisionKeyObj(crol, 'free', 0, crol.level);
            allKeyMap.set(key, obj);
          }
        });

      }
    }

    // map des clés & filtres de vision
    const visionKeyMap: Map<string, VisionKey> = new Map(
      Object.values(this.currentVision.visionKeys || {}).map((item: VisionKey) => [item.code, item])
    );
    const visionFilterKeyMap: Map<string, VisionFilterKey> = new Map(
      Object.values(this.currentVision.visionFilterKeys || {}).map((item: VisionFilterKey) => [item.code, item])
    );

    // tableaux de destination
    const frees: VisionKeyObj[] = [];
    const keys: VisionKeyObj[] = [];
    const filters: VisionKeyObj[] = [];

    // on ventile
    Array.from(allKeyMap.values()).forEach((item: VisionKeyObj) => {
      if (visionKeyMap.has(item.code)) {
        item.order = visionKeyMap.get(item.code).order;
        keys.push(item);
      } else if (visionFilterKeyMap.has(item.code)) {
        item.order = visionFilterKeyMap.get(item.code).order;
        filters.push(item);
      } else {
        frees.push(item);
      }
    });

    this.freeKeyDS.setSource(frees);
    this.keyDS.setSource(keys.sort((a, b) => (a.order >= b.order ? 1 : -1)));
    this.filterKeyDS.setSource(filters.sort((a, b) => (a.order >= b.order ? 1 : -1)));
    this.lstFreeKeys.wizDataProvider = this.freeKeyDS;
    this.lstKeys.wizDataProvider = this.keyDS;
    this.lstFilterKeys.wizDataProvider = this.filterKeyDS;
  }

  /**
   * focus du premier champs actif
   */
  public focusFormFields(): void {
    // focus du label si c'est une mise à jour
    if (this.clone.id > 0) {
      WizFocusManager.getInstance().wizSetFocus(this.tiLabelTrs);
    } else {
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }
  }

  /**
   * mise à false du model update
   */
  public resetModelUpdate() {
    // on informe que le model n'a pas de changement en cours
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
  }

  /** reset complet des champs */
  private reset(): void {
    this.tiCode.wizValue = null;
    this.tiLabelTrs.wizValue = null; // translatedLabel
    this.tiSupportMail.wizValue = null;
    this.tiHelpURL.wizValue = null;
    this.cbUseScen.wizChecked = false;
    this.cbWebNav.wizChecked = false;
    this.cbUsePdfExport.wizChecked = false
    this.cbAutoCompute.wizChecked = false;
    this.cbAutoCompute.wizChecked = false;
    this.tiComputeCron.wizValue = null;

    if (this.chronoDS) {
      this.chronoDS.select([]);
    }

    this.ddChrono.wizValue = null;
  }

  /**
   * Validateur d'unicité du code de la vision
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentChronocode est null
      if (this.clone === null || this.clone === undefined) {
        return null;
      }

      if (
        this.tiCode.wizValue !== null &&
        this.tiCode.wizValue &&
        this.tiCode.wizValue.length > 0 &&
        !(this.clone.id > 0)
      ) {
        // Recherche d'une autre avec le même code
        const vmap = Model.getInstance().visionEngine.getBuVisionMap();
        let other = null;
        if (!!vmap) {
          other = vmap.get(this.tiCode.wizValue.toUpperCase());
        }

        if (this.tiCode.wizValue.toUpperCase() === ViewData.wildcardMainVision || // pas __SETTINGS
          this.tiCode.wizValue.toUpperCase() === ViewData.wildcardDomainLiteral // ni WIZEOO
        ) {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }


        // Si la vision existe deja avec le meme code on affiche le message
        if (other) {
          const temp: WizValidationError = {
            wizError: '$.vision.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * clic sur le bouton "ajouter une vision"
   * @param e void
   */
  private askForAdd(): void {

    this.currentVision = Model.getInstance().visionEngine.buildFake();
    this.clone = Model.getInstance().visionEngine.clone(this.currentVision);
    this.feed();
  }

  /**
   * Demande d'ajout d'une vision depuit le contexte (génération externe)
   */
  public askForAddFromContext(): void {
    this.askForAdd();
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value);
    let noRealChange: boolean = false; // attention aux faux positifs sur clic dans les listes dragabbles

    switch (e.component) {
      case this.tiCode:
        this.clone.code = this.tiCode.wizValue?.toUpperCase();
        this.fixDeps();
        break;
      case this.tiLabelTrs:
        let labelVO: TranslatableLabelVO = Model.getInstance().visionEngine.getVisionProperties(this.clone, VISION_PROPERTY.LABEL);
        labelVO.updateTranslationEntry(e.value);

        // this.clone.labelVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsDesc:
        let descriptionVO: TranslatableLabelVO = Model.getInstance().visionEngine.getVisionProperties(this.clone, VISION_PROPERTY.DESCRIPTION);
        descriptionVO.updateTranslationEntry(e.value);
        // this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.uploadImg:
        this.clone.icon = e.value;
        this.uploadImg.sourceObservable = Model.getInstance().visionEngine.getVisionIconOrDie(this.clone); // mise à jour de l'image
        break;
      case this.ddStatus:
        this.clone.status = this.visionStateDS.selectedItem ? this.visionStateDS.selectedItem.code : null;
        break;
      case this.ddRunMode:
        this.clone.runMode = this.runModeDS.selectedItem ? this.runModeDS.selectedItem.code : null;
        break;
      case this.tiSupportMail:
        this.clone.supportMail = this.tiSupportMail.wizValue;
        break;
      case this.tiHelpURL:
        this.clone.helpURL = this.tiHelpURL.wizValue;
        break;
      case this.cbUseScen:
        this.clone.useScenario = this.cbUseScen.wizChecked;
        break;
      case this.cbWebNav:
        this.clone.navigationMode = this.cbWebNav.wizChecked ? ViewData.NAVIGATION_WEB : ViewData.NAVIGATION_TABLE;
        break;      
      case this.cbUsePdfExport:
        this.clone.usePdfExport = this.cbUsePdfExport.wizChecked;
        break;
      case this.cbUseCompute:
        this.clone.useCompute = this.cbUseCompute.wizChecked;
        if(!this.clone.useCompute) {
          this.clone.autoCompute = false;
          this.clone.computeCron = null;
          this.cbAutoCompute.wizChecked = false;
          this.tiComputeCron.wizValue = null;
        }
        break;  
      case this.cbAutoCompute:
        this.clone.autoCompute = this.cbAutoCompute.wizChecked;
        break;
      case this.tiComputeCron:
        this.clone.computeCron = this.tiComputeCron.wizValue;
        break;     
        
      case this.taSettings:
        this.clone.settingsStr = this.taSettings.wizValue;
        break;        

      case this.ddChrono:
        let newVal: string = this.ddChrono.selectedItem ? this.ddChrono.selectedItem.code : null;
        if (newVal !== this.clone.chronoCode) {
          this.clone.chronoCode = newVal;
          this.feedKeys(); // construction des listes des clés
          this.feedMeasures(); // construction de la liste des mesures
          this.resetSteps(); // ici, vérifier que les steps possèdent encore toutes les clés
          this.buildSteps(); // construction des steps
        } else {
          noRealChange = true; // rien passé, en fait
        }

        break;
      case this.lstKeys:

        let cloneKeysChanged: boolean = false; // on remet une clé qu'on a enlevée... change pour refresh des steps
        if (this.keyDS.length != Object.values(this.clone.visionKeys || {}).length) {
          cloneKeysChanged = true;
        }
        this.clone.visionKeys = Model.getInstance().visionEngine.visionObjToVisionKey(
          this.clone,
          this.currentVision,
          this.keyDS.getWorkedSource()
        );

        // si changement entre le clone et la source, reset sur les steps
        let realKey: string = Object.values(this.currentVision.visionKeys || {}).map((item) => item.code).join(ViewData.KEY_SEPARATOR);
        let cloneKey: string = Object.values(this.clone.visionKeys || {}).map((item) => item.code).join(ViewData.KEY_SEPARATOR);

        // console.log('keys', realKey, cloneKey);
        if (realKey !== cloneKey || cloneKeysChanged) {
          this.resetSteps(); // TODO ici, vérifier que les steps possèdent encore toutes les clés
        } else {
          noRealChange = true; // rien passé, en fait
        }

        break;
      case this.lstFilterKeys:
        this.clone.visionFilterKeys = Model.getInstance().visionEngine.visionObjToVisionFilterKey(
          this.clone,
          this.currentVision,
          this.filterKeyDS.getWorkedSource()
        );

        // si changement entre le clone et la source sur les filterKeys
        const realFKey: string = Object.values(this.currentVision.visionFilterKeys || {}).map((item) => item.code).join(ViewData.KEY_SEPARATOR);
        const cloneFKey: string = Object.values(this.clone.visionFilterKeys || {}).map((item) => item.code).join(ViewData.KEY_SEPARATOR);
        if (realFKey === cloneFKey) {
          noRealChange = true; // rien passé, en fait
        } else {
          this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        }
        break;
      case this.lstMeasures:
        this.clone.measures = Array.from(this.visionMeasureDS.getSource()).map(item => item.source);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
    }
    // on informe que le model a changé
    if (!noRealChange) {
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    }
  }

  /**
   * sur modification du code en mode création, mise à jour des vision_codes sur les sous-objets
   */
  private fixDeps(): void {
    // console.log('fixDeps', this.clone, this.clone.code);
    if(this.clone.visionFilterKeys) {
      Object.values(this.clone.visionFilterKeys).forEach((vfk: VisionFilterKey) => {
        vfk.visionCode = this.clone.code;
      })
    }
    if(this.clone.visionKeys) {
      Object.values(this.clone.visionKeys).forEach((vk: VisionKey) => {
        vk.visionCode = this.clone.code;
      })
    }
    if(this.clone.visionSteps) {
      Object.values(this.clone.visionSteps).forEach((vs: VisionStep) => {
        vs.visionCode = this.clone.code;
      })
    }
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public get disableButtons(): boolean {
    let result: boolean = true;
    if (!this.clone?.code) { // même pas de code...
      return result;
    }

    let labelVO: TranslatableLabelVO = Model.getInstance().visionEngine.getVisionProperties(this.clone, VISION_PROPERTY.LABEL);
    if (labelVO.hasEntry()) {
      result = false;
    }
    if (!result) {
      result = !ViewData.wizUpdateModel;
    }
    return result;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public get disableCancel(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /**
   * revert sur btCancel, simple resélection
   * @param e wizEvent
   */
  private doRevert(e: WizEvent): void {
    // this.visionKeyUpdateFlag = false;
    this.clone = Model.getInstance().visionEngine.clone(this.currentVision);
    this.feed();
  }

  /**
   * Indique si le drag & drop est actif en fonction des permissions utilisateurs
   */
  public get canDragDrop(): boolean {
    return Model.getInstance().permissionEngine.hasAnyPermission({
      feature: StaticFeatureEnum.VISION,
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
      visibility: PermissionVisibility.DISABLED,
    });
  }

  /* #############################################################
                 persistence
     ############################################################# */

  /** demande de suppression la vision */
  public askForDelete(): void {
    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doRemove.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this.currentVision
    ).show();
  }

  /**
   * Suppression de la vision
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
  private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().visionEngine.remove(this.clone, this.currentVision, this.backFromRemove.bind(this));
    }
  }

  /** suppression de la vision de la pile
   * @param e: le visionVO supprimé
   */
  private backFromRemove(vo: VisionVO, state: WIZ_COMMAND_STATE): void {
    // ViewData.wizUpdateModel = false;
    if (state === WIZ_COMMAND_STATE.SUCCESS) {
      this.visionDS.removeItem(vo);
      this.currentVision = null;
      this.clone = null;
      this.reset();
    }

  }

  /** demande de merge sur btOk */
  private doMerge(e: WizEvent): void {
    let errors = this.vgDetailZoneValidator.check(true, true);


    // patch pour alimentation correcte des settings
    if(this.clone.settingsStr) {
      try {
        this.clone.settings = JSON.parse(this.clone.settingsStr);
      }
      catch(e: any) {
      } 
    } else {
      this.clone.settings = null;
    }


    this.stepComponents.forEach((cref: ComponentRef<VisionStepRenderer>) => {
      errors = errors.concat(cref.instance.checkLabel(null));
    });

    if (errors && errors.length === 0) {
      // Vérification de la saisie
      // délégation au VisionManager. Il va appeler la commitCMD
      // si pas de chrono, on prend EON
      if (!this.clone.chronoCode) {
        this.clone.chronoCode = 'EON';
      }

      // contrôle des perimeters si changement de structure des clés

      // seulement si changement de structure des keys et pas création
      if (this.currentVision.id > 0 && Model.getInstance().visionEngine.keyChanged(this.currentVision, this.clone)) {
        if (this.currentVision && !Model.getInstance().visionEngine.getStepPerimeterList(this.currentVision)) { // vsp pas encore chargés
          new VisionStepPerimeterCommand(Model.getInstance()).find(this.currentVision, false, this.reallyMerge.bind(this)).execute();
        } else {
          Model.getInstance().visionEngine.merge(this.clone, this.currentVision, this.backFromMerge.bind(this));
        }
      } else {
        Model.getInstance().visionEngine.merge(this.clone, this.currentVision, this.backFromMerge.bind(this));
      }


    } else {
      WizPopUp.toast('$.vision.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  private reallyMerge(cmd: VisionStepPerimeterCommand): void {

    const stepMap: Map<string, VisionStepPerimeter> = Model.getInstance().visionEngine.getStepPerimeterList(this.currentVision);
    if (!stepMap || stepMap.size === 0) {
      Model.getInstance().visionEngine.merge(this.clone, this.currentVision, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.vision.hasperimeters.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback de l'ajout ou modification d'une vision
   * @param bddBack vision créée ou modifiée (le clone)
   */
  private backFromMerge(bddBack: VisionVO): void {

    this.visionDS.setSource([...Model.getInstance().visionEngine.visionDS.getSource()]);
    this.currentVision = bddBack;
    this.clone = Model.getInstance().visionEngine.clone(this.currentVision);
    this.feed();

    Model.getInstance().dataEngine.resetDatas();
  }

  /* #############################################################
                     gestion des mesures
     ############################################################# */

  /** ajout / suppression de toutes les mesures */
  private manageAllMeasures(doAdd: boolean = true): void {
    if (doAdd) { // ajout en masse
      let vals: MeasureVO[] = this.freeMeasureDS.getWorkedSource();
      if (vals.length > 0) {
        this.visionMeasureDS.addItem(vals);
        vals.forEach(m => {
          this.freeMeasureDS.removeItem(m);
        });
        this.clone.measures = Array.from(this.visionMeasureDS.getSource()).map(item => item.source);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        ViewData.wizUpdateModel = true;
        this.visionMeasureDS.refresh();
        this.freeMeasureDS.refresh();
      }
    } else { // suppression en masse
      let vals: MeasureVO[] = this.visionMeasureDS.getWorkedSource();
      if (vals.length > 0) {
        this.freeMeasureDS.addItem(vals);
        vals.forEach(m => {
          this.visionMeasureDS.removeItem(m);
        });
        this.clone.measures = Array.from(this.visionMeasureDS.getSource()).map(item => item.source);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        ViewData.wizUpdateModel = true;
        this.visionMeasureDS.refresh();
        this.freeMeasureDS.refresh();
      }
    }
  }

  /** ajout d'une mesure à la sélection */
  private addMeasure(e: AlkEvent): void {
    // console.log('add measure', e.data);
    this.visionMeasureDS.addItem(e.data);
    this.freeMeasureDS.removeItem(e.data);
    // #7669 On ne peut pas utiliser la worked source sinon on risque de retirer toutes les mesures si un filtre est appliqué
    this.clone.measures = Array.from(this.visionMeasureDS.getSource()).map(item => item.source); // Model.getInstance().visionEngine.syncMeasure(this.clone, this.currentVision, this.visionMeasureDS.getWorkedSource());
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    ViewData.wizUpdateModel = true;
    // this.checkFormulaIntegrity();
  }

  /** suppression d'une mesure de la sélection */
  private removeMeasure(e: AlkEvent): void {
    // console.log('remove measure', e.data);
    // TODO TODO (e.data as MeasureVO).hasError = false; // pas d'erreur dans le pool free
    this.freeMeasureDS.addItem(e.data);
    this.visionMeasureDS.removeItem(e.data);
    // #7669 On ne peut pas utiliser la worked source sinon on risque de retirer toutes les mesures si un filtre est appliqué
    this.clone.measures = Array.from(this.visionMeasureDS.getSource()).map(item => item.source); // Model.getInstance().visionEngine.syncMeasure(this.clone, this.currentVision, this.visionMeasureDS.getWorkedSource());
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    ViewData.wizUpdateModel = true;
    // this.checkFormulaIntegrity();
  }

  /** modification du filtre des mesures */
  private filterMeasures(e: WizEvent): void {
    this.freeMeasureDS.refresh();
    this.visionMeasureDS.refresh();
  }

  /** modification du filtre des freeKeys */
  private filterKeys(e: WizEvent): void {
    this.freeKeyDS.refresh();
  }

  /**
   * filtre des 2 listes de mesures
   * @param item measure
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private measureFilterFunc(item: MeasureVO): boolean {
    return this.freeMeasureFilter.checkVisible(item);
  }

  /**
   * filtre la liste des visions pour masquer les visions de conf (BU)
   * @param item visionVO
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private visionFilterFunc(item: VisionVO): boolean {
    if (Model.getInstance().visionEngine.getVisionProperties(item, VISION_PROPERTY.ISCONFIGAPP)) { // on affiche pas les visions de config
      return false;
    }

    return true;
  }



  /**
   * filtre des keys disponibles
   * @param item visionKeyObj
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private freeKeysFilterFunc(item: VisionKeyObj): boolean {
    return this.lstFreeKeysFilter.checkVisible(item);
  }

  /* #############################################################
                     gestion des steps
     ############################################################# */

  /** les zones de steps */
  public stepComponents: ComponentRef<VisionStepRenderer>[];

  /** suppression des rendus de steps */
  private clearSteps(): void {
    this.stepContainer.clear(); // vider le container des favoris
    this.stepComponents = []; // on rince la référence aux filtres
  }

  /** construction des zones de steps */
  protected buildSteps() {
    this.clearSteps();


    Object.values(this.clone.visionSteps || {})
      .sort((a, b) => (a.level >= b.level ? 1 : -1))
      .forEach((step: VisionStep) => {
        // et on crée les composants
        const meCompo: ComponentRef<VisionStepRenderer> = WizComponentManager.instance.addChildTo(
          VisionStepRenderer,
          this.stepContainer,
          {
            instanceProperties: { data: step, view: this, vision: this.clone },
          }
        );
        this.stepComponents.push(meCompo);
      });
  }

  /** modification de la structure de clé, on rince tous les steps sauf le premier */
  private resetSteps(): void {
    Object.values(this.clone.visionKeys || {}).forEach((vkvo: VisionKey) => { // on rince les stepLevels sur les keys
      vkvo.stepLevel = 1;
    });

    let existOrCreate: VisionStep = Model.getInstance().visionEngine.addStep(this.clone, 1); // on récupère le 1er, ou on le prend s'il existe
    this.clone.visionSteps = {}; // on rince la map de steps
    this.clone.visionSteps[existOrCreate.level] = existOrCreate; // et on en remet 1

    this.buildSteps(); // et on construit
  }

  /**
   * méthode globale de changement de step
   * @param key les clés en cours de déplacement. Le niveau cible a été alimenté dans le renderer
   * @param down boolean. si true, vers le bas...sinon, up
   */
  private keyStepChange(keys: VisionKey[], down: boolean) {
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL

    let cleanKeyMap: Map<number, VisionKey[]> = new Map<number, VisionKey[]>(); // clé de VisionKeyVO par stepLevel
    let maxRequestedLevel: number = 0; // prise du niveau max demandé
    Object.values(this.clone.visionKeys || {}).forEach(vk => {
      if (!cleanKeyMap.has(vk.stepLevel)) {
        cleanKeyMap.set(vk.stepLevel, []);
      }
      cleanKeyMap.get(vk.stepLevel).push(vk);
      maxRequestedLevel = Math.max(vk.stepLevel, maxRequestedLevel);
    });

    // suppression des levels vides (on fait ça pour éviter les)
    let currentIdx: number = 1; // indice en cours de test

    while (currentIdx <= maxRequestedLevel) {
      if (!cleanKeyMap.has(currentIdx)) { // l'indice n'est pas dans la map, il y un trou 
        Array.from(cleanKeyMap.keys()).forEach((key: number) => { // un trou dans la map, on abaisse tous les niveaux supérieurs
          if (key > currentIdx) {
            cleanKeyMap.get(key).forEach((vk: VisionKey) => {
              vk.stepLevel--;
            });
          }
        });
        // et rebelote...
        Object.values(this.clone.visionKeys || {}).forEach(vk => {
          if (!cleanKeyMap.has(vk.stepLevel)) {
            cleanKeyMap.set(vk.stepLevel, []);
          }
          cleanKeyMap.get(vk.stepLevel).push(vk);
          maxRequestedLevel = Math.max(vk.stepLevel, maxRequestedLevel);
        });

        currentIdx = 1;
      } else {
        currentIdx++;
      }
    }

    // y'avait peut-être une demande sur un step vide
    let realMax: number = 0;
    Object.values(this.clone.visionKeys || {}).forEach(vk => {
      realMax = Math.max(vk.stepLevel, realMax);
    });


    if (!this.clone.visionSteps) {
      this.clone.visionSteps = {};
    }

    let lvl: number = realMax;

    while (lvl > 0) {
      Model.getInstance().visionEngine.addStep(this.clone, lvl); // ajout du step inexistant
      lvl--;
    }

    // et on enlève les morts
    Object.values(this.clone.visionSteps).forEach(vs => {
      if (vs.level > realMax) {
        delete this.clone.visionSteps[vs.level];
      }
    });

    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.buildSteps();
  }

  /**
   * demande de passage de la clé au step supérieur
   * @param e l'event depuis les boutons des steps [VisionKeyObj, DS]
   */
  private keyStepUp(e: AlkEvent): void {
    this.keyStepChange(e.data, false);
  }

  /**
   * demande de passage de la clé au step inférieur
   * @param e l'event depuis les boutons des steps [VisionKeyObj, DS]
   */
  private keyStepDown(e: AlkEvent): void {
    this.keyStepChange(e.data, true);
  }

  /**
   * Demande de chargement d'une image
   */
  public clickForUpload(): void {
    let params: ImageUploadParameter = {
      component: this.uploadImg,
      elementRef: this.uploadImg.elementRef,
      dom: this.currentVision.domain,
      bu: this.currentVision.businessUnitCode,
      vision: ViewData.wildcardMainVision
    }
    Model.getInstance().batchEngine.loadImage(params);
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload();
    }
  }

  /** affichage de l'icone de suppression des... icones */
  public hasImage(): boolean {
    return !!this.clone?.icon;
  }

  /**  de suppression des... icones */
  public clearImage(): void {
    this.clone.icon = null;
    this.uploadImg.sourceObservable = Model.getInstance().visionEngine.getVisionIconOrDie(this.clone);
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // console.log('backFromImport',e);
    if (e && (e.data === BATCH_KIND.VISION || e.data === BATCH_KIND.META_VISION)) {
      new FindVisionCommand(Model.getInstance()).find(this.backFromReload.bind(this)).execute();
    }
  }

  private backFromReload(e: any): void {
    // console.log('backFromReload',e);
    this.wizSynchronizeData();
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  public backgroundColor = StyleEngine.STYLE_DEFAULT_BAR_COLOR; // --grid-header-background-color

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.blockBack.nativeElement, pEvent.target, this.backgroundColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    this.backgroundColor = color;
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    this.clone.color = this.backgroundColor;
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    this.backgroundColor = StyleEngine.STYLE_DEFAULT_BAR_COLOR; // --grid-header-background-color
    this.feedHeaderStyle();
  }

  public isCronValid(cron: any) {
    var cronregex = new RegExp(/^(\*|([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])|\*\/([0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|1[0-9]|2[0-9]|3[0-1])|\*\/([1-9]|1[0-9]|2[0-9]|3[0-1])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|([0-6])|\*\/([0-6]))$/);
    return cronregex.test(cron);
  }

  /**
   * Validateur du cron compute
   */
  public cronValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentChronocode est null
      if (this.clone === null || this.clone === undefined) {
        return null;
      }

      if (
        this.tiComputeCron.wizValue !== null &&
        this.tiComputeCron.wizValue &&
        this.tiComputeCron.wizValue.length > 0
      ) {
        // Recherche d'une autre avec le même code
        let cron: string = this.tiComputeCron.wizValue;
       
        if (!this.isCronValid(cron)) {
          const temp: WizValidationError = {
            wizError: '$.compute.cron.error.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  } 


}
